import { Route } from "@angular/router";

import { checkIfLoggedInFn } from "../../core/guards";
import { PageMode } from "../../shared/constants/enums";
import { createUserGroupsPageGuards, viewUserGroupsPageGuards } from "./_guards";
import { UserGroupsEditorComponent } from "./user-groups-editor/user-groups-editor";
import { UserGroupsComponent } from "./user-groups-list/user-groups";

export const USER_GROUPS_ROUTES: Route[] = [
  {
    path: "users-groups",
    canActivate: [checkIfLoggedInFn, ...viewUserGroupsPageGuards],
    children: [
      {
        path: "list",
        redirectTo: "",
      },
      {
        path: "",
        component: UserGroupsComponent,
      },
      {
        path: "create",
        canActivate: [...createUserGroupsPageGuards],
        component: UserGroupsEditorComponent,
        data: {
          title: "breadcrumbs.new_user_group",
          breadcrumb: "breadcrumbs.new_user_group",
          pageMode: PageMode.create,
        },
      },
      {
        path: ":id",
        component: UserGroupsEditorComponent,
        data: {
          title: "breadcrumbs.view_user_group",
          breadcrumb: "breadcrumbs.view_user_group",
          pageMode: PageMode.view,
        },
      },
      {
        path: "edit/:id",
        component: UserGroupsEditorComponent,
        data: {
          title: "breadcrumbs.edit_user_groups",
          breadcrumb: "breadcrumbs.edit_user_groups",
          pageMode: PageMode.edit,
        },
      },
    ],
    data: {
      title: "user_groups.title",
      breadcrumb: "user_groups.title",
    },
  },
];
